export default [{
        path: `/volunteer/home`,
        name: 'volunteerHome',
        redirect: '/volunteer/home/rule',
        meta: {
            title: '志愿者之家-上饶美术馆',
            keepAlive: true
        },
        children: [{
                path: '/volunteer/home/rule',
                name: 'volunteerRule',
                meta: {
                    title: '志愿者章程-上饶美术馆',
                    keepAlive: true
                },
                component: () =>
                    import ('../views/volunteer/volunteerRule.vue')
            },
            {
                path: '/volunteer/home/ruleRegister',
                name: 'volunteerActivityRegister',
                meta: {
                    title: '志愿者章程-上饶美术馆',
                    keepAlive: false
                },
                component: () =>
                    import ('../views/volunteer/volunteerActivityRegister.vue')
            },
            {
                path: '/volunteer/home/activity',
                name: 'volunteerActivity',
                meta: {
                    title: '志愿者活动-上饶美术馆',
                    keepAlive: false
                },
                component: () =>
                    import ('../views/volunteer/volunteerActivity.vue'),
                children: []
            },
            {
                path: '/volunteer/home/activityDetail',
                name: 'volunteerActivityDetail',
                meta: {
                    title: '志愿者活动-上饶美术馆',
                    keepAlive: false
                },
                component: () =>
                    import ('../views/volunteer/volunteerActivityDetail.vue'),
                props: (route) => {
                    return {
                        id: route.query.id
                    }
                }
            }
        ],
        component: () =>
            import ('../views/volunteer/volunteerHome.vue'),
    },
    // {
    //     path: `/volunteer/rule`,
    //     name: '志愿者章程',
    //     meta: {
    //         title: '观众服务-志愿者章程',
    //     },
    //     component: () =>
    //         import ('../views/volunteer/volunteerHome.vue'),
    // },

]